import PropTypes from 'prop-types';
import React from 'react';

import { HtmlContentLoader, WysiwygStyleWrapper } from '@powdr/components';
import { Alignment } from '@powdr/constants';
import { colorProfileByIndex } from '@powdr/utils';

import { StyledUiFooter } from './styles';

export const UiFooter = ({
  html = { value: '' },
  footerAlignment = Alignment.CENTER,
  paddingBottom = 50,
  paddingTop = 50,
  colorProfile = null,
  parentColorProfile = null,
}) => {
  const trueColorProfile = (colorProfile) ? colorProfileByIndex(colorProfile) : parentColorProfile;

  return (
    <StyledUiFooter
      alignment={footerAlignment}
      colorProfile={trueColorProfile}
      $paddingTop={(paddingTop === null) ? 50 : paddingTop}
      $paddingBottom={(paddingBottom === null) ? 50 : paddingBottom}
    >
      <WysiwygStyleWrapper colorProfile={parentColorProfile}>
        <HtmlContentLoader html={html?.value} allowRerender />
      </WysiwygStyleWrapper>
    </StyledUiFooter>
  );
};

UiFooter.propTypes = {
  html: PropTypes.shape({
    value: PropTypes.string,
  }),
  footerAlignment: PropTypes.string,
  paddingBottom: PropTypes.number,
  paddingTop: PropTypes.number,
  colorProfile: PropTypes.string,
  parentColorProfile: PropTypes.string,
};
